import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ICustomGetCalificacionesReq, IResDescargaArchivo, IResRegistroCalificaciones, ITabla } from 'src/app/interfaces/calificaciones';
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class RegistroCalificacionesService {
  constructor(
    private http: HttpClient
  ) { }

  getHeaders(): HttpHeaders {
    return new HttpHeaders();
  }

  getCalificaciones(customReq: ICustomGetCalificacionesReq): Observable<ITabla> {
    const url = `${environment.endpointDocente}/v1/registro-calificacion/obtenerTabla?anyo=${customReq.anyo}&periodo-id=${customReq.periodoId}&asignatura-id=${customReq.asignaturaId}&sede-id=${customReq.sedeId}&seccion-id=${customReq.seccionId}`
    return this.http.get<ITabla>(url, {headers: this.getHeaders()})
  }

  // validar si se elimina
  getCalificacionesTablaInfo(customReq: ICustomGetCalificacionesReq): Observable<any> {
    const url = `${environment.endpointDocente}/v1/registro-calificacion/obtenerTablaInfo?anyo=${customReq.anyo}&periodo-id=${customReq.periodoId}&asignatura-id=${customReq.asignaturaId}&sede-id=${customReq.sedeId}&seccion-id=${customReq.seccionId}`
    return this.http.get<any>(url, {headers: this.getHeaders()})
  }

  getCalificacionesTablaHeaders(customReq: ICustomGetCalificacionesReq): Observable<any> {
    const url = `${environment.endpointDocente}/v1/registro-calificacion/obtenerTablaHeader?anyo=${customReq.anyo}&periodo-id=${customReq.periodoId}&asignatura-id=${customReq.asignaturaId}&sede-id=${customReq.sedeId}&seccion-id=${customReq.seccionId}`
    return this.http.get<any>(url, {headers: this.getHeaders()})
  }

  getCalificacionesTablaSeccion(customReq: ICustomGetCalificacionesReq): Observable<any> {
    const url = `${environment.endpointDocente}/v1/registro-calificacion/obtenerTablaSeccion?anyo=${customReq.anyo}&periodo-id=${customReq.periodoId}&asignatura-id=${customReq.asignaturaId}&sede-id=${customReq.sedeId}&seccion-id=${customReq.seccionId}`
    return this.http.get<any>(url, {headers: this.getHeaders()})
  }


  postRegistroCalificacion(body: any): Observable<IResRegistroCalificaciones> {
    const url = `${environment.endpointDocente}/v1/registro-calificacion/crearRegistroCalificacion`
    return this.http.post<IResRegistroCalificaciones>(url, body, {headers: this.getHeaders()})
  }

  descargarRegistroCalificaciones(customReq: ICustomGetCalificacionesReq): Observable<IResDescargaArchivo> {
    const url = `${environment.endpointDocente}/v1/registro-calificacion/descargar?anyo=${customReq.anyo}&periodo-id=${customReq.periodoId}&asignatura-id=${customReq.asignaturaId}&sede-id=${customReq.sedeId}&seccion-id=${customReq.seccionId}`
    return this.http.get<IResDescargaArchivo>(url, {headers: this.getHeaders()})
  }

  postCierreSeccion(body: ICustomGetCalificacionesReq): Observable<IResRegistroCalificaciones> {
    const url = `${environment.endpointDocente}/v1/registro-calificacion/cierreSeccion`
    return this.http.post<IResRegistroCalificaciones>(url, body, {headers: this.getHeaders()})
  }
}
